"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("./userInfoState"));
const mobileProfileState_1 = __importDefault(require("../MobileTabBar/mobileProfileState"));
const webview_app_1 = require("@/webview_app");
const api_1 = require("@/api");
function default_1({ expectNoLogin }) {
    const [userInfo, setUserInfo] = (0, recoil_1.useRecoilState)(userInfoState_1.default);
    const resetUserInfo = (0, recoil_1.useResetRecoilState)(userInfoState_1.default);
    const setMobileProfileState = (0, recoil_1.useSetRecoilState)(mobileProfileState_1.default);
    const resetMobileProfile = (0, recoil_1.useResetRecoilState)(mobileProfileState_1.default);
    const { isNativeApp } = window;
    const setMemberInfos = (infos) => {
        setUserInfo(Object.assign(Object.assign({}, infos), { isLoggedIn: !!infos.user_id, ready: true }));
        const { profile_img_url, has_new } = infos;
        setMobileProfileState({ profile_img_url, has_new });
        isNativeApp && (0, webview_app_1.postMessageToWVA)('LOGGEDIN');
    };
    const setNonMemberDefaults = () => {
        setUserInfo(Object.assign(Object.assign({}, userInfo), { ready: true }));
        resetMobileProfile();
        isNativeApp && (0, webview_app_1.postMessageToWVA)('LOGGEDOUT');
    };
    (0, react_1.useLayoutEffect)(() => {
        if (!userInfo.ready) {
            if (expectNoLogin) {
                setNonMemberDefaults();
            }
            else {
                (0, api_1.getData)('/api/v1/members/simple-info')
                    .then(res => {
                    const { result } = res.data;
                    setMemberInfos(result);
                })
                    .catch(err => err.response.status === 403 && setNonMemberDefaults());
            }
        }
        else {
            return () => resetUserInfo();
        }
    }, [userInfo.ready]);
    return userInfo;
}
exports.default = default_1;
